export enum ProjectFeedbackType {
  TEAM = 1,
  CLIENT = 2,
}

export interface ProjectRatingDepartment {
  department_id: number;
  rating: number;
}

export interface ProjectRatingBase {
  project_id: number;
  type: ProjectFeedbackType;
  overall_rating?: number;
  cost_incurred?: number;
  feedback?: string;
  files?: string[];
}

export interface ProjectRatingRequest extends ProjectRatingBase {
  ratings: ProjectRatingDepartment[];
}

export interface ProjectRatingResponse extends ProjectRatingBase {
  id?: number;
  rating?: number;
  cost_impact?: number;
  departments?: ProjectRatingDepartment[];
  feedbacks?: Array<{
    department_id: number;
    rating?: number;
  }>;
}

export interface DepartmentRating {
  department: string;
  rating: number;
}

export interface FeedbackRatings {
  overallRating: number;
  departmentRatings: DepartmentRating[];
}

export interface FeedbackFormFields {
  comment: string;
  lossIncurred: string;
  files: File[];
}

export interface FeedbackSubmissionPayload {
  type: ProjectFeedbackType;
  overallRating: number;
  departmentRatings: DepartmentRating[];
  comment: string;
  lossIncurred: string;
  files: File[] | string[];
  archiveAfter: boolean;
  shouldClose?: boolean;
}

export type ExistingRatingForPrefill = Pick<
  ProjectRatingResponse,
  "type" | "overall_rating" | "rating" | "cost_incurred" | "feedback" | "files" | "departments" | "feedbacks"
>;